import { useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { BUSINESS_INFO_ONE } from '../../../../paths';
import { RootState } from '../../../../store';
import { resetAddressLookup } from '../../../address-verification/reducers/addressLookup';
import { BusinessInfoTwoForm } from '../../components/business-info-2-form';

const selector = ({ addressLookup: { error: addressError }, nextStep: { error: appError } }: RootState) => ({
  error: addressError ?? appError,
});

const BusinessInfoTwoPage: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector(selector);

  const handleBack = () => {
    navigate(BUSINESS_INFO_ONE);
  };

  useEffect(() => {
    dispatch(resetAddressLookup());
  }, [dispatch]);

  return (
    <WizardPage
      title="Tell us more about your business"
      subtext="We need some more details to verify your business."
      error={error}
      onBack={handleBack}
      footer={<YouCanComeBackNote />}
    >
      <BusinessInfoTwoForm />
    </WizardPage>
  );
};

export { BusinessInfoTwoPage };
